module.exports = __webpack_public_path__ + "img/subscribe-main-bg.3a41ad0f.svg";